import React from "react";
import { getContentPageProps } from "../logic/contentLogic";

const NewsArchive = React.lazy(() => import("../components/NewsArchive"));

export const renderNewsArchiveContent = (content, props = {}) => {
  const Helmet = props.helmet;

  return (
    <>
      <Helmet />
      <NewsArchive key={content.id} {...getContentPageProps(content)} />
    </>
  );
};
